/**
 * fetch wrapper — strips internal timeout/retry options used by legacy native HTTP.
 */
export async function apiFetch(url, init = {}) {
    const {
        _singleHttpAttempt,
        _httpConnectTimeoutMs,
        _httpReadTimeoutMs,
        ...rest
    } = init;
    return fetch(url, rest);
}
